import React from 'react';

const FooterView = ({
  clientId,
  setGoalId,
  goalObj,
}: {
  clientId: string;
  setGoalId(any, string): void;
  goalObj: any;
}) => {
  return (
    <section id="NewFinancialPlan_footer_nav">
      {goalObj && goalObj.prev && (
        <a
          href="#"
          className="prev"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();

            setGoalId(goalObj.prev, clientId);
          }}
        >
          <i className="fa fa-angle-left" />
          <strong>Previous:</strong> {goalObj.prev.label}
        </a>
      )}
      {goalObj && goalObj.next && (
        <a
          href="#"
          className="next"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();

            setGoalId(goalObj.next, clientId);
          }}
        >
          <strong>Next:</strong> {goalObj.next.label}
          <i className="fa fa-angle-right" />
        </a>
      )}
    </section>
  );
};

export default FooterView;
